import { render, staticRenderFns } from "./PayFinish.vue?vue&type=template&id=5c75074e&scoped=true"
import script from "./PayFinish.vue?vue&type=script&lang=js"
export * from "./PayFinish.vue?vue&type=script&lang=js"
import style0 from "./PayFinish.vue?vue&type=style&index=0&id=5c75074e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75074e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c75074e')) {
      api.createRecord('5c75074e', component.options)
    } else {
      api.reload('5c75074e', component.options)
    }
    module.hot.accept("./PayFinish.vue?vue&type=template&id=5c75074e&scoped=true", function () {
      api.rerender('5c75074e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/PayFinish.vue"
export default component.exports